// src/common/Button.js
import classNames from "classnames";

export default function Button({
  children,
  onClick,
  type = "button",
  variant = "primary",
  className = "",
  disabled = false,
  loading = false,
  // `size` is accepted and ignored: padding currently lives inside each variant,
  // so honouring it would need those to be restructured. Swallowed here so it
  // can't reach the DOM as an invalid <button size="..."> attribute.
  // eslint-disable-next-line no-unused-vars
  size,
  ...props
}) {
  const baseStyles =
    "text-sm font-medium transition duration-200 rounded focus:outline-none focus:ring-2 focus:ring-offset-2";

  const variants = {
    primary:
      "bg-smiles-blue text-white px-4 py-2 hover:bg-smiles-orange/80 dark:hover:bg-smiles-orange focus:ring-smiles-orange",
    secondary:
      "bg-white border border-smiles-orange text-smiles-orange px-4 py-2 hover:bg-smiles-orange/10 dark:bg-gray-800 dark:border-orange-300 focus:ring-smiles-orange",
    outline:
      "bg-white border border-gray-300 text-gray-700 px-4 py-2 hover:bg-gray-50 focus:ring-smiles-blue",
    ghost:
      "bg-transparent text-gray-700 px-4 py-2 hover:bg-gray-100 focus:ring-smiles-blue",
    link: "text-smiles-blue bg-transparent hover:underline px-0 py-0 dark:text-blue-300 focus:ring-smiles-orange",
    danger:
      "bg-smiles-orange text-white px-4 py-2 hover:bg-red-600 focus:ring-red-400",
    disabled:
      "bg-gray-300 text-gray-600 cursor-not-allowed px-4 py-2 dark:bg-gray-700 dark:text-gray-500",
  };

  const isDisabled = disabled || loading;

  const finalClassName = classNames(
    baseStyles,
    isDisabled ? variants["disabled"] : variants[variant],
    className
  );

  return (
    <button
      type={type}
      className={finalClassName}
      onClick={onClick}
      disabled={isDisabled}
      aria-busy={loading || undefined}
      {...props}
    >
      {loading && (
        <span
          aria-hidden="true"
          className="inline-block h-3.5 w-3.5 mr-2 -mb-0.5 rounded-full border-2 border-current border-r-transparent animate-spin"
        />
      )}
      {children}
    </button>
  );
}
